import { useEffect } from "react";
import { FormTextarea, useFormContext } from "@jsq/ds/forms";

interface Props {
  description: string;
}

const EscalationWaiverFormValues = ({ description }: Props) => {
  const { setFieldValue } = useFormContext();

  useEffect(() => {
    setFieldValue("description", description);
  }, [description, setFieldValue]);

  return <FormTextarea isFullWidth disabled name="description" label="Escalation Issue" />;
};

export default EscalationWaiverFormValues;
